import React, { FC } from 'react'
import { styled } from '@creditas/stylitas'
import { isBefore, subDays } from 'date-fns'

const BulletWrapper = styled.div<{ danger?: boolean }>`
  background-color: ${props => (props.danger ? '#dd2222' : '#ff7711')};
  border-radius: 4px;
  display: inline-block;
  height: 8px;
  margin-left: 6px;
  width: 8px;
`

const contactlessCustomerForMoreThanOneDay = (assignments: Workflow[] = []) =>
  assignments.findIndex(({ scheduling }) => {
    if (!scheduling || isBefore(new Date(scheduling), subDays(new Date(), 1))) {
      return true
    }

    return false
  }) >= 0

const Bullet: FC<{ assignments?: Workflow[] }> = ({ assignments }) => {
  if (!assignments || !Array.isArray(assignments) || assignments.length === 0) {
    return <></>
  }

  if (assignments.findIndex(assignment => assignment.hasPendency) > -1) {
    return <BulletWrapper danger />
  }

  if (contactlessCustomerForMoreThanOneDay(assignments)) {
    return <BulletWrapper />
  }

  return <></>
}

export { Bullet }
